import React from 'react';
import type { ColumnType } from 'antd/es/table';
import { SupportQCTask } from '@dynamika-shared/types/subjects';

export type QCTaskGroupRow = {
  type: 'group';
  key: string;
  task: string;
  started?: string;
  finished?: string;
  assignee: string;
  assigneeEmail?: string;
  status?: string;
};

export enum QCTaskDetailSubheaderKindEnum {
  EXEC = 'subheader-exec',
  DXA = 'subheader-dxa',
  CT = 'subheader-ct',
  XRAY = 'subheader-xray',
  MRI = 'subheader-mri',
  PDF = 'subheader-pdf',
  CSV = 'subheader-csv',
  MISC = 'subheader-misc',
}

type QCTaskDetailBase = {
  type: 'detail';
  key: string;
  groupKey: string;
};

export type QCTaskDetailSubheaderRow = QCTaskDetailBase & {
  detailKind: QCTaskDetailSubheaderKindEnum;
};

export type QCTaskDetailExecRow = QCTaskDetailBase & {
  detailKind: 'exec';
  label?: string;
  startDate?: string;
  endDate?: string;
  assignee?: string;
  assigneeEmail?: string;
  status?: string;
};

type DicomDetailKind = Exclude<Lowercase<Modality>, 'dxa'>;

export type QCTaskDetailDXARow = QCTaskDetailBase & {
  detailKind: 'dxa';
  label: string;
  acquisitionDate?: string;
  workstation?: string;
};

export type QCTaskDetailDicomRow = QCTaskDetailBase & {
  detailKind: DicomDetailKind;
  label: string;
  acquisitionDate?: string;
  dicomSeriesUid?: string;
};

export type QCTaskDetailRow =
  | QCTaskDetailSubheaderRow
  | QCTaskDetailExecRow
  | QCTaskDetailDXARow
  | QCTaskDetailDicomRow;

export type QCTaskRow = QCTaskGroupRow | QCTaskDetailRow;

export type QCTasksTableConfigOptions = {
  iconColWidth?: number;
  detailIconIndentPx?: number;

  headerBgClass?: string;
  rowBgClass?: string;
  headerBgInline?: string;
  rowBgInline?: string;
  headerTextClass?: string;

  dataFontSizePx?: number;
  dataLineHeightPx?: number;

  actionIconSizeClass?: string;
  dateTextClass?: string;
  timeTextClass?: string;
};

export type Props = {
  clinicalTrialId?: string;
  patientId?: string;
  visitId?: string | null;
  tasks: SupportQCTask[];
  loading?: boolean;
  error?: Error;
};

export enum Modality {
  DXA = 'DXA',
  CT = 'CT',
  XRAY = 'XRAY',
  MRI = 'MRI',
  PDF = 'PDF',
  CSV = 'CSV',
  MISC = 'MISC',
}

export type VisitInfo = {
  id?: string | null;
  visitName?: string;
  visitOrder?: number;
};

export type SliceState = {
  qcTasksByKey?: Record<string, SupportQCTask[]>;
  qcTasksLoading?: boolean;
  qcTasksError?: Error;
  visitDatesByKey?: Record<string, { visits?: VisitInfo[] }>;
};

export type HeaderAttrs = React.HTMLAttributes<HTMLElement>;

export type OnHeaderCell = NonNullable<
  NonNullable<ColumnType<QCTaskRow>['onHeaderCell']>
>;
